export default __webpack_public_path__ + "static/media/rate.3b776d62.svg";